import { ApplyToEnum } from './apply-to-enum';

export class ApplyToModel {
  applyTo: ApplyToEnum = null;
  excludedComputers = [];
  selectedCompanies = [];
  selectedComputers = [];
}
